export function handleScrollingSection($section, direction = "right", minWidth = 0 ) {
    if ($section.length !== 1) {
        return;
    }

    let offset = 0;
    let dragging = false;
    let lastX = -1;
    let velocity = 0;
    let totalWidth = 0;
    let enabled = false;
    let lastFrame = (new Date).getTime();

    let $wrap = $section.find(".js-scrolling-wrap");
    let $groups = $section.find(".js-scrolling-item");

    let mouseMove = function (e) {
        let diff = lastX - e.pageX;
        lastX = e.pageX;

        if (direction === "left") {
            diff = -diff;
        }

        setTestimonialOffset(offset + diff);
        velocity = diff;
    };

    let mouseUp = function (e) {
        $(window).off("mousemove", mouseMove).off("mouseup", mouseUp);
        dragging = false;
        lastFrame = (new Date).getTime();
    };
    let touchMove = function (e) {
        let diff = lastX - e.originalEvent.touches[0].pageX;
        lastX = e.originalEvent.touches[0].pageX;

        setTestimonialOffset(offset + diff);
        velocity = diff;
    };

    let touchEnd = function (e) {
        $(window).off("touchmove", touchMove).off("touchcancel touchend", touchEnd);
        dragging = false;
    };


    $groups.on("mousedown", function (e) {
        if (!enabled) {
            return true;
        }
        if (dragging) {
            return false;
        }
        dragging = true;

        lastX = e.pageX;
        $(window).on("mousemove", mouseMove).on("mouseup", mouseUp);

        return false;
    }).on("touchstart", function (e) {
        if (!enabled || e.originalEvent.cancelable === false) {
            return true;
        }
        if (dragging) {
            return false;
        }
        dragging = true;

        lastX = e.originalEvent.touches[0].pageX;
        $(window).on("touchmove", touchMove).on("touchcancel touchend", touchEnd);

        return false;
    });

    $(window).on("resize", function () {
        if ($(window).outerWidth() >= minWidth) {
            if (enabled) {
                updateTotalWidth();
                setTestimonialOffset(offset);
            } else {
                offset = 0;
                enable();
            }
        } else {
            disable();
        }
    });

    if ($(window).outerWidth() >= minWidth) {
        enable();
    }

    function enable() {
        if (enabled) {
            return;
        }

        enabled = true;
        updateTotalWidth();
        $groups.css("position", "absolute");
        if (direction === "left") {
            $groups.css("right", "0px");
        }
        updateLayout();
        requestAnimationFrame(updateTestimonialSlider);
    }

    function disable() {
        if (!enabled) {
            return;
        }

        enabled = false;
        $groups.css("position", "").css("left", "").css("right", "").css("transform", "");
        $wrap.css("transform", "");

        dragging = false;
        $(window).off("touchmove", touchMove).off("touchcancel touchend", touchEnd).off("mousemove", mouseMove).off("mouseup", mouseUp);
    }

    function updateTotalWidth() {
        totalWidth = 0;
        $groups.each(function (_, group) {
            totalWidth += $(group).outerWidth();
        });
    }

    function updateTestimonialSlider() {
        if (!enabled) {
            return;
        }
        if (!dragging) {
            let now = (new Date).getTime();
            let dt = now - lastFrame;
            lastFrame = now;


            setTestimonialOffset(offset + (dt / 18.333) + velocity);
            velocity *= 0.85;
        }
        requestAnimationFrame(updateTestimonialSlider);
    }

    function setTestimonialOffset(_offset) {
        offset = _offset;

        offset = offset % totalWidth;
        if (offset < 0) {
            offset += totalWidth;
        }

        if (direction === "left") {
            $wrap.css("transform", "translate3d(" + offset + "px, 0, 0)");
        } else {
            $wrap.css("transform", "translate3d(" + -offset + "px, 0, 0)");
        }

        updateLayout();
    }

    function updateLayout() {
        let offSideOffset = 0;
        let seenOffset = 0;

        $groups.each(function (index, group) {
            let $group = $(group);

            let groupWidth = $group.outerWidth();

            if (seenOffset + groupWidth - offset < 0) {
                if (direction === "left") {
                    $group.css("transform", "translateX(-" + (totalWidth + offSideOffset) + "px)");
                } else {
                    $group.css("transform", "translateX(" + (totalWidth + offSideOffset) + "px)");
                }

                offSideOffset += groupWidth;
            } else {
                if (direction === "left") {
                    $group.css("transform", "translateX(-" + seenOffset + "px)");
                } else {
                    $group.css("transform", "translateX(" + seenOffset + "px)");
                }
            }
            seenOffset += groupWidth;
        });
    }
}